import React from 'react';
import FormLabel from '@mui/material/FormLabel';

function Label({ children, htmlFor, className, ...props }) {
  return (
    <FormLabel htmlFor={htmlFor} className={className} {...props}>
      {children}
    </FormLabel>
  );
}

export default Label;
